import { useCallback } from "react";

// TODO: remove this and test pinned columns in aggrids next upgrade

// AG Grid v36 leaves `.ag-header-row`'s inline width stale after the side
// bar is shown/hidden, while the body's `.ag-grid-scrolling-container`
// width is recalculated correctly — this desyncs the sticky-positioned
// pinned-right header from its body cells. There's no public API to force
// this recalculation (confirmed against the v36.1.0 API reference), so we
// copy the correct width across as a DOM-level stopgap until AG Grid fixes
// it upstream. Scoped via the grid's own data-tour attribute, since a ref
// isn't always available (e.g. AgGridContainer's WrapperComponent is a
// swappable prop that may not forward refs).
//
// Exported separately from the hook so it can be exercised directly in
// tests without needing to render a React tree.
export const syncStaleHeaderRowWidth = (tableName: string): void => {
  let wrapper: HTMLElement | null = null;
  try {
    wrapper = document.querySelector<HTMLElement>(
      `[data-tour="${tableName}"]`,
    );
  } catch {
    return;
  }
  // .ag-grid-scrolling-container is the v36.0.0 rename of the old
  // .ag-body-viewport (AG Grid's "DOM Structure Redesign", AG-16834) —
  // if a future AG Grid version renames this again, correctWidth will
  // silently become undefined and this fix will silently no-op.
  const correctWidth = wrapper?.querySelector<HTMLElement>(
    ".ag-grid-scrolling-container",
  )?.style.width;
  if (!wrapper || !correctWidth) return;

  wrapper
    .querySelectorAll<HTMLElement>(".ag-header-row")
    .forEach(headerRow => {
      if (headerRow.style.width !== correctWidth) {
        headerRow.style.width = correctWidth;
      }
    });
};

export const useAgGridHeaderWidthFix = (tableName: string) =>
  useCallback(() => {
    requestAnimationFrame(() => syncStaleHeaderRowWidth(tableName));
  }, [tableName]);
